/**
 * @pageName ContactFullPage
 * @slotType dashboard menu plugin
 */
export type ContactMainMoreActionsMenuParams = {
  /*Contact ID.*/ contactId: string;
};
